var map = {
	"./bikbok.svg": 5516,
	"./finn.png": 3731,
	"./kondomeriet.png": 6868,
	"./lyko.png": 2267,
	"./makeup-mekka.png": 9402,
	"./pierre-robert.svg": 502,
	"./the-body-shop.png": 9796,
	"./volt-logo.svg": 9207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5002;